import { Scale } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useApp } from "@/context/AppContext";
import { mediaSrc } from "@/lib/api";

export default function LegalAdvisorDialog({ trigger }) {
  const { settings, t, pick, lang } = useApp();
  const a = settings.legal_advisor || {};
  const photo = mediaSrc(settings.media?.legal_photo);
  const name = pick(a, "name");
  const title = pick(a, "title");
  const bio = pick(a, "bio");
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className={`glass max-w-2xl rounded-3xl border-amber-200/30 text-emerald-50 ${lang === "ml" ? "lang-ml" : ""}`} data-testid="legal-advisor-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-white">{t("knowLegalAdvisor")}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
          {photo ? (
            <img src={photo} alt={name || "Legal Advisor"} data-testid="legal-advisor-photo" className="h-28 w-28 rounded-2xl object-cover ring-1 ring-amber-200/40" />
          ) : (
            <div data-testid="legal-advisor-photo" className="flex h-28 w-28 items-center justify-center rounded-2xl bg-amber-200/10 ring-1 ring-amber-200/30">
              <Scale className="h-12 w-12 text-amber-200/80" />
            </div>
          )}
          <div>
            <p className="font-display text-xl font-semibold text-white" data-testid="legal-advisor-name">{name || "To be announced"}</p>
            {title && <p className="text-sm text-amber-200">{title}</p>}
          </div>
        </div>
        {bio ? (
          <ScrollArea className="max-h-[50vh] pr-3">
            <p className="whitespace-pre-line text-sm leading-relaxed text-emerald-50/85" data-testid="legal-advisor-bio">{bio}</p>
          </ScrollArea>
        ) : (
          <p className="text-sm text-emerald-100/60" data-testid="legal-advisor-empty">Details will be shared here soon.</p>
        )}
      </DialogContent>
    </Dialog>
  );
}
